import { computed, inject } from "vue";
import { MAIN_PAGE } from "../consts/injectProvideKeys.js";
export function useImage(image, page, parentPage) {
  const apiImage = () => {
    if (!image) {
      return;
    }
    const isBackground = image.backgroundImage ? "backgroundImage" : "imagelink";
    if (image[isBackground]?.$ref) {
      const content = computed(() => page.getContent(image[isBackground]));
      if (content.value) {
        return content.value?.model?.data;
      }
      if (!parentPage) {
        parentPage = inject(MAIN_PAGE);
      }
      if (parentPage) {
        const parentContent = parentPage.getContent(image[isBackground]);
        return parentContent?.model?.data;
      }
    }
    if (image[isBackground]) {
      return image[isBackground];
    }
    return void 0;
  };
  return { image: apiImage() };
}
